import type { SearchTargets } from '@components/Explorer/search';
import type { Group, User } from '@types';

export const EMPTY_GROUPS: Group[] = [];
export const EMPTY_USERS: User[] = [];
export const DEFAULT_SEARCH_TARGETS: SearchTargets = {
  users: true,
  groups: true,
  places: true,
};
